import React from "react";
import CommonCard from "../components/global/card";

const Footer = () => {
  return (
    <CommonCard className={"!mt-4 mx-6 mb-2"}>
      <div className="flex justify-center items-center w-full">
        <p className="text-center text-sm font-medium text-primary"> Copyright {(new Date().getFullYear())} LeadsImport.com. All Rights Reserved.</p>
      </div>
    </CommonCard>
  );
};
export default Footer;
